import { ExpressContactKind } from "../../types/express-master.type";
import { EXPRESS_PATH } from "../ExpressData/constants";
import { ALL } from "../CreditDebitNote/constants";

export const EXPRESS_CONTACT_MENU_TITLE = "ผู้จำหน่าย / ลูกค้า";
export const EXPRESS_ACCOUNT_MENU_TITLE = "รหัสบัญชี";

export const EXPRESS_CONTACT_PATH = `${EXPRESS_PATH}/contacts`;
export const EXPRESS_ACCOUNT_PATH = `${EXPRESS_PATH}/accounts`;

export const CONTACT_KIND_LABEL: Record<ExpressContactKind, string> = {
  SUPPLIER: "ผู้จำหน่าย",
  CUSTOMER: "ลูกค้า",
};

export const CONTACT_KINDS: ExpressContactKind[] = ["SUPPLIER", "CUSTOMER"];

export const CONTACT_KIND_FILTER: { value: ExpressContactKind | typeof ALL; label: string }[] = [
  { value: ALL, label: "ทั้งหมด" },
  ...CONTACT_KINDS.map((kind) => ({ value: kind, label: CONTACT_KIND_LABEL[kind] })),
];

/** The list's status filter; a code is never deleted, only switched off. */
export type ActiveFilter = typeof ALL | "ACTIVE" | "INACTIVE";

export const ACTIVE_FILTER_OPTIONS: { value: ActiveFilter; label: string }[] = [
  { value: ALL, label: "ทั้งหมด" },
  { value: "ACTIVE", label: "ใช้งาน" },
  { value: "INACTIVE", label: "ปิดใช้งาน" },
];

/** `is_active` for the list query; nothing for ทั้งหมด. */
export const isActiveParam = (filter: ActiveFilter): boolean | undefined =>
  filter === ALL ? undefined : filter === "ACTIVE";

/** The server's column sizes. */
export const MASTER_CODE_MAX_LENGTH = 20;
export const MASTER_NAME_MAX_LENGTH = 150;
export const CONTACT_TITLE_MAX_LENGTH = 40;
export const CONTACT_ADDRESS_MAX_LENGTH = 255;
export const CONTACT_PHONE_MAX_LENGTH = 50;
export const MASTER_SEARCH_MAX_LENGTH = 100;
